/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Cohort } from './cohort';
import type { IdReference } from './idReference';

export type UserUpdateCohort = Cohort | IdReference | null;
